import $ from "jquery";
import "when-in-viewport";

$(document).ready(function() {
    $("section.off-screen .col").addClass("off-screen");
    $(".off-screen").whenInViewport((element) => {
      setTimeout(() => {
        element.removeClass("off-screen").addClass("on-screen");
      }, 100);
    });

});



// WEBPACK FOOTER //
// ./scroll-in-animate/scroll-in-animate.js